import type { ClientType, LegalType } from '@shared/documents'
import { roundRubAmountString } from '@shared/money'

const getContractDateValue = (date = new Date()) =>
  [date.getUTCDate(), date.getUTCMonth() + 1, date.getUTCFullYear()]
    .map((v) => String(v).padStart(2, '0'))
    .join('.')

export type DocsFormValues = {
  clientType: ClientType
  legalType: LegalType
  contractDate: string
  fullNameRu: string
  fullNameEn: string
  birthDate: string
  passportSeriesNumber: string
  passportIssuedByRu: string
  passportIssuedByEn: string
  passportIssueDate: string
  passportDivisionCode: string
  regAddressRu: string
  regAddressEn: string
  legalAddressRu: string
  legalAddressEn: string
  legalActualAddressRu: string
  legalActualAddressEn: string
  psrnsp: string
  organizationNameRu: string
  organizationNameEn: string
  positionRu: string
  positionEn: string
  kpp: string
  ogrn: string
  tin: string
  legalBankRu: string
  legalBankEn: string
  legalSettlementAccount: string
  legalCorrespondentAccount: string
  bic: string
  supplierName: string
  invoiceNo: string
  productName: string
  invoiceDate: string
  invoiceAmount: string
  invoiceCurrency: string
  supplierAddress: string
  supplierAccount: string
  supplierBank: string
  supplierBankAddress: string
  supplierBankBranch: string
  supplierBankCode: string
  correspBank: string
  correspBankAddress: string
  correspBankCode: string
  correspBankAccount: string
  conversionRate: string
  amountRub: string
  reportSignedDate: string
  birthPlace: string
  clientPhone: string
  clientEmail: string
  securityPaymentRub: string
  vehicleBrandModel: string
  vinOrBody: string
  vehicleYear: string
  purchaseCountry: string
  auctionLot: string
  agentRewardPercent: string
  contractNo: string
}

export const normalizeRubAmounts = (
  values: DocsFormValues,
): DocsFormValues => ({
  ...values,
  amountRub: roundRubAmountString(values.amountRub),
  securityPaymentRub: roundRubAmountString(values.securityPaymentRub),
})

export const getFormInitState = (): DocsFormValues => ({
  clientType: 'individual',
  legalType: 'ip',
  contractDate: getContractDateValue(),
  fullNameRu: '',
  fullNameEn: '',
  birthDate: '',
  passportSeriesNumber: '',
  passportIssuedByRu: '',
  passportIssuedByEn: '',
  passportIssueDate: '',
  passportDivisionCode: '',
  regAddressRu: '',
  regAddressEn: '',
  legalAddressRu: '',
  legalAddressEn: '',
  legalActualAddressRu: '',
  legalActualAddressEn: '',
  psrnsp: '',
  organizationNameRu: '',
  organizationNameEn: '',
  positionRu: '',
  positionEn: '',
  kpp: '',
  ogrn: '',
  tin: '',
  legalBankRu: '',
  legalBankEn: '',
  legalSettlementAccount: '',
  legalCorrespondentAccount: '',
  bic: '',
  supplierName: '',
  invoiceNo: '',
  productName: '',
  invoiceDate: getContractDateValue(),
  invoiceAmount: '',
  invoiceCurrency: '',
  supplierAddress: '',
  supplierAccount: '',
  supplierBank: '',
  supplierBankAddress: '',
  supplierBankBranch: '',
  supplierBankCode: '',
  correspBank: '',
  correspBankAddress: '',
  correspBankCode: '',
  correspBankAccount: '',
  conversionRate: '',
  amountRub: '',
  reportSignedDate: getContractDateValue(
    new Date(Date.now() + 4 * 24 * 60 * 60_000),
  ),
  birthPlace: '',
  clientPhone: '',
  clientEmail: '',
  securityPaymentRub: '',
  vehicleBrandModel: '',
  vinOrBody: '',
  vehicleYear: '',
  purchaseCountry: '',
  auctionLot: '',
  agentRewardPercent: '3',
  contractNo: '',
})
